import { CustomSelect as Select } from './Select';

export type { SelectProps } from './types';

export default Select;
